export const DIALOG_TYPES = {
    EXCEL_UPLOAD_PART: "EXCELUPLOADPART",
    EXCEL_UPLOAD_ALL: "EXCELUPLOADALL",
}
